const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import BagItem from "./bag_item";
import BagBufftem from "./bag_buff_item";
import TimeManager from "../../../../manager/time_manager";

@ccclass
export default class BagView extends ViewBase {

    @property(cc.Node)
    daojuNode:cc.Node = null

    @property(cc.Node)
    vipNode:cc.Node = null

    @property(cc.Node)
    daojuChoose:cc.Node = null

    @property(cc.Node)
    vipChoose:cc.Node = null

    @property(cc.Node)
    buffItemNode:cc.Node = null

    @property(cc.Node)
    buffItemGrid:cc.Node = null

    @property(cc.Node)
    bagItemNode:cc.Node = null

    @property(cc.Node)
    bagItemGrid:cc.Node = null

    buffItemList = []
    bagItemList = []
    

    changeBtnShow(isDaoJu){
        this.daojuChoose.active = isDaoJu
        this.vipChoose.active = !isDaoJu
        this.daojuNode.active = isDaoJu
        this.vipNode.active = !isDaoJu
    }

    //显示BUFF道具时间
    updateShowBuffStatus(data){
        let buff1 = {itemName:"เคาน์เตอร์", itemDesc:"สามารถใช้ในดัมมี่และไพ่แคงได้",itemCode:"Item_Recorder", endTime: TimeManager.instance.getServerTime() * 1000}
        let buff2 = {itemName:"ผู้ช่วยไพ่แคง", itemDesc:"ช่วยเหลือการเปิดไพ่แคง",itemCode:"Item_BpCalculator", endTime: TimeManager.instance.getServerTime() * 1000}
        if (data == null || data.length <= 0 ){
            data = []
        }
        //为了先判断是否已经有了这两个BUFF
        let isAddBuff1 = true
        let isAddBuff2 = true
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.itemCode == "Item_Recorder" || element.itemCode == "JPQ_ITEM"){
                isAddBuff1 = false
            }
            if (element.itemCode == "Item_BpCalculator"){
                isAddBuff2 = false
            }
        }
        if (isAddBuff1){
            data.push(buff1)
        }

        if (isAddBuff2){
            data.push(buff2)
        }

        let dataCount = data != null ? data.length : 0
        for (let index = 0; index < dataCount; index++) {
            const element = data[index];
            if (this.buffItemList[index] == null){
                let obj = cc.instantiate(this.buffItemNode)
                this.buffItemGrid.addChild(obj)
                this.buffItemList[index] = obj.getComponent(BagBufftem)
            }
            this.buffItemList[index].showBuffInfo(element, this)
        }

        if (this.buffItemList.length > dataCount){
            for (let index = dataCount + 1; index < this.buffItemList.length; index++) {
                this.buffItemList[index].showBuffInfo(null, this)
            }
        }
    }

    //更新显示所有道具
    updateShowItem(data){
        let addItem = {isGoShop:true}
        data[data.length] = addItem
        let dataCount = data != null ? data.length : 0
        for (let index = 0; index < dataCount; index++) {
            const element = data[index];
            if (this.bagItemList[index] == null){
                let obj = cc.instantiate(this.bagItemNode)
                this.bagItemGrid.addChild(obj)
                this.bagItemList[index] = obj.getComponent(BagItem)
            }
            this.bagItemList[index].showItemInfo(element)
        }

        if (this.bagItemList.length > dataCount){
            for (let index = dataCount; index < this.bagItemList.length; index++) {
                this.bagItemList[index].showItemInfo(null)
            }
        }
    }



}